import { useNavigate } from '@remix-run/react';
import clsx from 'clsx';

interface ButtonFilterProps {
	label: string;
	url: string;
	active?: boolean;
}

export function ButtonFilter({ label, url, active }: ButtonFilterProps) {
	const navigate = useNavigate();

	return (
		<div className="flex items-center">
			<button
				id={url}
				className={clsx(
					'px-[15px] py-[5px] rounded-3xl border border-blue font-belfast text-xs font-bold',
					active && 'bg-blue text-white',
				)}
				onClick={() => {
					navigate(url);
				}}
			>
				{label}
			</button>
		</div>
	);
}
